// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2WN1U","container":"Footer_container__20GB2","send":"Footer_send__3U7HE","black":"Footer_black__1NJCm"};